import { CommentType, Issue } from '../../shared/shared.interface';
import { User } from '../types/user';

export const useIssues = () => useState<Issue[]>(
    'issues',
    () => []
);
export const useComments = () => useState<CommentType[]>(
    'comments',
    () => []
);
export const useIsEditIssue = () => useState<boolean>(
    'isEditissue',
    () => false
);
export const useUser = () => useState<User>(
    'user',
    () => ({
        name: '',
        email: '',
        avatar: '',
        sub: '',
        role_id: '',
        permissions: []
    })
);
